'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseValueHierarchy = exports.isSameValueAsPrevious = undefined;
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');
var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var isSameValueAsPrevious = exports.isSameValueAsPrevious = function isSameValueAsPrevious(value, previousValue) {
  var valueHierarchicalPath = R.append(value.id, R.propOr([], 'parents', value));
  var previousValueHierarchicalPath = R.append(previousValue.id, R.propOr([], 'parents', previousValue));
  return R.equals(valueHierarchicalPath, previousValueHierarchicalPath);
};
var parseValueHierarchy = exports.parseValueHierarchy = function parseValueHierarchy(value, previousValue, indexedValues) {
  var parentsIds = R.propOr([], 'parents', value);
  if (R.isEmpty(parentsIds)) {
    return value;
  }
  var _previousParentsIds = R.propOr([], 'parentsIds', previousValue);
  var previousParentsIds = R.isNil(previousValue) ? [] : R.append(R.prop('id', previousValue), _previousParentsIds);
  var _R$addIndex = R.addIndex(R.splitWhen)(function (val, ind) {
      return R.nth(ind, previousParentsIds) !== val;
    }, parentsIds),
    _R$addIndex2 = (0, _slicedToArray3.default)(_R$addIndex, 2),
    presentIds = _R$addIndex2[0],
    _missingIds = _R$addIndex2[1];
  var __previousParentsIds = R.pipe(R.propOr([], 'parents'), R.pluck('id'))(previousValue);
  var missingIds = R.pipe(R.takeLastWhile(function (id) {
    return !R.includes(id, __previousParentsIds) && id !== R.prop('id', previousValue);
  }), function (ids) {
    return R.concat(ids, _missingIds);
  })(presentIds);
  var _previousParents = R.propOr([], 'parents', previousValue);
  var previousParents = R.isNil(previousValue) ? [] : R.append(R.pick(['id', 'name'], previousValue), _previousParents);
  var parents = R.takeWhile(function (p) {
    return R.includes(p.id, presentIds);
  }, previousParents);
  var missingParents = R.props(missingIds, indexedValues);
  return (0, _extends3.default)({}, value, {
    parents: parents,
    parentsIds: parentsIds,
    missingParents: missingParents
  });
};